import { QueryClient } from "react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
      keepPreviousData: false,
      staleTime: 0,
      cacheTime: 0,
    },
  },
});

